<template>
  <div v-cloak class="event">
    <!-- 头部banner图 -->
    <div class="swiper"></div>

    <!-- 中间内容 -->
    <div class="container o-h pa-b-40">
      <div class="ma-t-30"><Bread :list="breadList" /></div>

      <div class="ma-t-30">
        <!-- <div class="flex ma-b-20">
          <div class="tab-item-1" @click="activeName=0" :class="activeName==0?'tab-item-active':''">全部</div>
          <div class="tab-item-2" @click="activeName=1" :class="activeName==1?'tab-item-active':''">最新</div>
          <div class="tab-item-3" @click="activeName=2" :class="activeName==2?'tab-item-active':''">热门</div>
        </div> -->
        <div class="flex f-wrap">
          <div
            v-for="(item, index) in dataList"
            :key="index"
            @click="toDetail(item.Id)"
            class="item-box ma-b-20 c-pointer"
          >
            <img :src="item.MainImage" :alt="item.Name" srcset="" class="item-img" />
            <div class="pa-10">
              <div class="font-bold t-omit-1 fon-20" >
                 {{item.Name}}
              </div>
              <div class="pa-t-10 pa-b-10 c-666 summary">
                {{item.Summary}}
              </div>
              <div class="flex f-between ma-t-10">
                <div class="c-red font-bold fon-22">{{item.Type}}</div>
                <div class="c-FF7200">仅剩 {{item.MaxCount-item.ApplyCount}}名额</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="dataList.length == 0" class="width100">
          <div class="t-center ma-t-40">
            <img src="../../img/empty.png" alt="" srcset="" width="200" />
            <div class="c-999">暂无数据</div>
          </div>
        </div>
      </div>

      <div class="fy">
        <el-pagination
          @current-change="handleCurrentChange"
          :hide-on-single-page="true"
          :current-page.sync="pageIndex"
          :page-size="16"
          layout="prev, pager, next, jumper"
          :total="totals"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@media  (max-width: 768px){
  .item-box{width: 100% !important;}
  
}
.summary{
  text-overflow:ellipsis;
  overflow: hidden;
  white-space:nowrap;
}
.tab-item-1,.tab-item-2,.tab-item-3{
  border: 1px solid #A0A0A0;
  padding: 10px 40px;
  color: #666666;
  cursor: pointer;
  box-sizing: border-box;
}
.tab-item-1{
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.tab-item-2{
}
.tab-item-3{
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.tab-item-active{
  color: #fff;
  font-weight: bold;
  background: #FA004C;
  border: 1px solid #FA004C;
}

.c-FF7200{
  color: #FF7200;
}
.o-h {
  overflow: hidden;
}
body {
  background: #f5f7fa;
}
.container {
  padding-left: 30px;
  padding-right: 30px;
  background: #fff;
  box-sizing: border-box;
}
.swiper {
  width: 100%;
  height: 314px;
  background-image: url(../../img/cf-bg.png);
  background-size: cover;
  background-position: bottom;
  position: relative;
}
.item-box {
  background: #fff;
  box-shadow: 0px 0px 12px 0px rgb(0 0 0 / 20%);
  border-radius: 6px;
  margin-right: 1%;
  width:32%;
  .item-img {
    width: 100%;
    height: auto;
  }
}
.progress-box {
  width: 100%;
  height: 6px;
  background: rgb(219, 219, 219);
  .progress-line {
    height: 100%;
    background: red;
  }
}
</style>
  <script>
  import { getActivityList } from "../../api.js";
import Bread from "../../components/Bread.vue";

// studycollect
export default {
  name: "event",
  components: { Bread },
  data() {
    return {
      activeName: "0",
      kinds: [{ Id: "0", Name: "全部" }],
      totals: 0, //一个分类下的总条数
      pageIndex: 1,
      dataList: [],
      breadList: [{ name: "活动列表", path: "/event/list" }],
    };
  },

  created() {
    // console.log("created----");
    this.getList();
  },

  // 其他页面进来时更新初始数据
  activated() {
    // console.log("909090------");
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);

    next();
  },

  methods: {
    getList() {
      let token = localStorage.getItem("AccessToken");
      let data = {
        token: token,
        source: "web",
        pageIndex: this.pageIndex,
        pageSize: 12,
      };
      console.log(data);
      getActivityList(data).then((res) => {
        if (res.data.Code == 0) {
          this.dataList = res.data.Data.List;
          this.totals = res.data.Data.TotalCount;
        }
      });
    },
    toDetail(id = 1) {
      //  this.$router.push({
      //   path: "/Img",
      //   query: { id: id },
      // });
      this.$router.push({
        path: "/event/detail",
        query: { id: id },
      });
    },

    //点击切换种类
    handleClick() {
      // console.log(tab);
      this.pageIndex = 0;
      this.getList();
    },

    // 当前页改变时触发
    handleCurrentChange(e) {
      this.pageIndex = e - 1;
      this.getList();
    },
  },
};
</script>
  